export default __webpack_public_path__ + "1896730.png";